import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Input,
  message,
  Button,
  Space,
  Spin,
  Typography,
  notification,
  Modal,
  Card,
  Tooltip,
  Alert,
  Select,
  Row,
  Col,
  Statistic,
} from "antd";
import {
  SearchOutlined,
  FilePdfOutlined,
  EditOutlined,
  ClearOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import getVisitaTecnicaById from "../../../services/visitas_tecnicas/visita_tecnica/getVisitaTecnicaByIdService";
import { selectAppPermissions } from "../../../store/auth/selectors";
import FormularioVisitaTecnicaSostenibilidad from "./FormVisitaTecnicaSostenibilidad";
import PdfVisitaTecnicaSostenibilidad from "./pdfVisitaTecnicaSostenibilidad";
import Header188 from "../../header/header";
import {
  getVisitasTecnicasSostenibilidad,
  getVisitaTecnicaSostenibilidadById,
} from "../../../services/sostenibilidad/visitaTecnicaSostenibilidad/viistaTecnicaSostenibilidadService";
import ExportVisitasTecnicasSostenibilidad from "./VisitasTecnicasSostenibilidadExcel";

const { Text, Title } = Typography;
const { Option } = Select;

const TablaVisitaTecnicaSostenibilidad = () => {
  const [visitasTecnicas, setVisitasTecnicas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const [showForm, setShowForm] = useState(false); // Estado para controlar la visibilidad del formulario
  const [showFormModal, setShowFormModal] = useState(false); // Estado para controlar la visibilidad del modal

  const [initialData, setInitialData] = useState({}); // Estado para manejar los datos iniciales

  const [showPdfVisitasTecnicas, setShowPdfVisitasTecnicas] = useState(false); // Estado para mostrar el componente pdfVisitasTecnicas

  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [modalidad, setModalidad] = useState([]);

  const [selectedDepartamento, setSelectedDepartamento] = useState(null);
  const [selectedMunicipio, setSelectedMunicipio] = useState(null);
  const [selectedModalidad, setSelectedModalidad] = useState(null);

  const appName = "visitas-tecnicas-sostenibilidad";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );
  const permissionInsert = permissions.priv_insert === "Y";
  const permissionUpdate = permissions.priv_update === "Y";
  const permissionExport = permissions.priv_export === "Y";
  const permissionPrint = permissions.priv_print === "Y";

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const handleCancel = () => {
    if (initialData && Object.keys(initialData).length > 0) {
      Modal.confirm({
        title: "¿Está segur@ de que desea cerrar?",
        content:
          "Si cierra esta ventana, la información ingresada no se guardará.",
        okText: "Sí, cerrar",
        cancelText: "No",
        onOk: () => {
          setShowFormModal(false);
          setInitialData({});
        },
      });
    } else {
      Modal.confirm({
        title: "¿Está segur@ de que desea cerrar?",
        content:
          "Si cierra esta ventana, la información ingresada no se guardará.",
        okText: "Sí, cerrar",
        cancelText: "No",
        onOk: () => {
          setShowFormModal(false);
          setInitialData({});
        },
      });
    }
  };
  const fetchVisitasTecnicas = async () => {
    try {
      const response = await getVisitasTecnicasSostenibilidad();
      const { status, data } = response;

      if (status === 200) {
        setVisitasTecnicas(data);
        setFilteredData(data || []);
      } else {
        setVisitasTecnicas([]);
        setFilteredData([]);
        notification.error({
          message: "Error",
          description:
            typeof message === "string"
              ? message
              : "Failed to fetch visitas técnicas de sostenibilidad data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchVisitaTecnicaById_update = async (id) => {
    try {
      const response = await getVisitaTecnicaSostenibilidadById(id);
      const { status, data } = response;

      if (status) {
        setInitialData(data);
        setShowFormModal(true); // Abre el modal
      } else {
        notification.error({
          message: "Error",
          description:
            typeof response.message === "string"
              ? response.message
              : "Failed to fetch visita técnica data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };
  const fetchVisitaTecnicaById_pdf = async (id) => {
    try {
      const response = await getVisitaTecnicaSostenibilidadById(id);
      const { status, data } = response;

      if (status) {
        setInitialData(data);
        setShowPdfVisitasTecnicas(true); // Abre el modal
      } else {
        notification.error({
          message: "Error",
          description:
            typeof response.message === "string"
              ? response.message
              : "Failed to fetch visita técnica data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };
  useEffect(() => {
    fetchVisitasTecnicas();
  }, []);

  useEffect(() => {
    if (!visitasTecnicas || visitasTecnicas.length === 0) {
      setDepartamentos([]);
      setSelectedDepartamento(null);
      setFilteredData([]);
      return;
    }

    // Obtener lista única de departamentos de las visitas técnicas
    const uniqueDepartamentos = [
      ...new Set(visitasTecnicas.map((p) => p.departamento)),
    ].sort();
    setDepartamentos(uniqueDepartamentos);
    setSelectedDepartamento(null);

    // Obtener lista única de modalidad de las visitas técnicas
    const uniqueModalidad = [
      ...new Set(visitasTecnicas.map((p) => p.modalidad)),
    ].sort();
    setModalidad(uniqueModalidad);
    setFilteredData(visitasTecnicas);
  }, [visitasTecnicas]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    filterData(
      selectedDepartamento,
      selectedMunicipio,
      value,
      selectedModalidad
    );
  };

  const filterData = (departamento, municipio, texto, modalidad) => {
    let filtered = [...visitasTecnicas];
    // Filtro por departamento (si está seleccionado en el select)
    if (departamento) {
      filtered = filtered.filter((v) => v.departamento === departamento);
    }
    // Filtro por municipio (si está seleccionado en el select)
    if (municipio) {
      filtered = filtered.filter((v) => v.municipio === municipio);
    }

    // Filtro por modalidad (si está seleccionado en el select)
    if (modalidad) {
      filtered = filtered.filter((v) => v.modalidad === modalidad);
    }

    if (texto?.trim()) {
      // Verifica que no sea nulo, vacío o solo espacios
      filtered = filtered.filter((visitaTecnica) =>
        Object.values(visitaTecnica).some(
          (val) =>
            typeof val === "string" &&
            val.toLowerCase().includes(texto.toLowerCase())
        )
      );
    }

    // Actualiza los datos filtrados
    setFilteredData(filtered);
  };

  const handleClearFilters = () => {
    setSelectedDepartamento(null);
    setSelectedMunicipio(null);
    setSearchText("");
    setFilteredData(visitasTecnicas);
    setSelectedModalidad(null);
  };

  const handleDepartamentoChange = (value) => {
    setSelectedDepartamento(value);
    setSelectedMunicipio(null); // Resetear municipio cuando cambia departamento

    // Obtener municipios del departamento seleccionado
    const municipiosFiltrados = [
      ...new Set(
        visitasTecnicas
          .filter((p) => p.departamento === value)
          .map((p) => p.municipio)
      ),
    ].sort();
    setMunicipios(municipiosFiltrados);

    // Filtrar datos
    filterData(value, null, searchText, selectedModalidad);
  };

  const handleModalidadChange = (value) => {
    setSelectedModalidad(value);
    // Filtrar datos
    filterData(selectedDepartamento, selectedMunicipio, searchText, value);
  };

  const handleMunicipioChange = (value) => {
    setSelectedMunicipio(value);
    filterData(selectedDepartamento, value, searchText, selectedModalidad);
  };

  const columns = [
    {
      title: "Acciones",
      key: "acciones",
      ellipsis: true,
      fixed: "left",
      width: 100,
      render: (text, record) => (
        <Space>
          {permissionUpdate && (
            <Tooltip title="Editar Visita Técnica">
              <Button
                style={{ backgroundColor: "#FFA500", color: "#fff" }}
                icon={<EditOutlined />}
                onClick={() => {
                  fetchVisitaTecnicaById_update(record.id);
                }}
              ></Button>
            </Tooltip>
          )}
          {permissionPrint && (
            <Tooltip title="Descargar PDF">
              <Button
                type="default"
                icon={<FilePdfOutlined />}
                style={{ backgroundColor: "#1890ff", color: "#fff" }}
                onClick={() => {
                  fetchVisitaTecnicaById_pdf(record.id);
                }}
              ></Button>
            </Tooltip>
          )}
        </Space>
      ),
    },
    {
      title: "Fecha registro",
      dataIndex: "fecha_registro",
      key: "fecha_registro",
      width: 130,
      align: "center",
    },
    {
      title: "Número de visita",
      dataIndex: "numero_visita",
      key: "numero_visita",
      width: 120,
      align: "center",
    },
    {
      title: "Código interno",
      dataIndex: "codigo_interno",
      key: "codigo_interno",
      width: 120,
    },
    {
      title: "Organización",
      dataIndex: "nombreFormaAsociativa",
      key: "nombreFormaAsociativa",
      width: 120,
    },
    {
      title: "Modalidad",
      dataIndex: "modalidad",
      key: "modalidad",
      width: 120,
    },
    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 150,
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 150,
    },
    {
      title: "Código PREPP",
      dataIndex: "codigoPREPP",
      key: "codigoPREPP",
      width: 150,
    },
    {
      title: "Linea productiva",
      dataIndex: "linea_productiva",
      key: "linea_productiva",
      width: 150,
    },
    {
      title: "Nombre del proyecto",
      dataIndex: "nombreProyecto",
      key: "nombreProyecto",
      width: 150,
      ellipsis: true, // Permite el truncamiento del texto
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
              width: "150px",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      {/* Renderiza solo el formulario si showForm es true */}
      {showForm ? (
        <div className="form-container">
          <FormularioVisitaTecnicaSostenibilidad initialData={{}} />{" "}
          {/* Pasa un objeto vacío para la creación */}
        </div>
      ) : showPdfVisitasTecnicas ? (
        <PdfVisitaTecnicaSostenibilidad
          formData={initialData}
          onClose={() => setShowPdfVisitasTecnicas(false)} // Función para cerrar el componente
        />
      ) : (
        <>
          {/* Aquí va el resto del contenido que deseas mostrar cuando no se está creando una novedad */}
          {loading ? (
            <div className="text-center">
              <Spin size="large" />
            </div>
          ) : (
            <>
              <div className="container">
                <div style={{ padding: "20px" }}>
                  <Header188 type="s_vt" />
                  <Row gutter={[16, 16]} className="mb-4">
                    <Col span={24}>
                      <div className="filter-container">
                        <Row gutter={[16, 16]} align="middle">
                          {/* Filtro Departamento */}
                          <Col xs={24} sm={12} md={5} lg={3}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Departamento
                              </Title>
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Seleccione departamento"
                                allowClear
                                onChange={handleDepartamentoChange}
                                value={selectedDepartamento}
                                showSearch
                                optionFilterProp="children" // busca dentro del texto de las opciones
                              >
                                {departamentos.map((depto) => (
                                  <Select.Option key={depto} value={depto}>
                                    {depto}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          </Col>

                          {/* Filtro Municipio */}
                          <Col xs={24} sm={12} md={5} lg={3}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Municipio
                              </Title>
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Seleccione municipio"
                                allowClear
                                disabled={!selectedDepartamento}
                                onChange={handleMunicipioChange}
                                value={selectedMunicipio}
                                showSearch
                                optionFilterProp="children" // busca dentro del texto de las opciones
                              >
                                {municipios.map((muni) => (
                                  <Select.Option key={muni} value={muni}>
                                    {muni}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          </Col>

                          {/* Filtro Modalidad */}
                          <Col xs={24} sm={12} md={5} lg={3}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Modalidad
                              </Title>
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Seleccione departamento"
                                allowClear
                                onChange={handleModalidadChange}
                                value={selectedModalidad}
                                showSearch
                                optionFilterProp="children" // busca dentro del texto de las opciones
                              >
                                {modalidad.map((m) => (
                                  <Select.Option key={m} value={m}>
                                    {m}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          </Col>

                          {/* Barra de búsqueda */}
                          <Col xs={24} sm={12} md={7} lg={4}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Búsqueda
                              </Title>
                              <Input
                                placeholder="Buscar..."
                                prefix={<SearchOutlined />}
                                value={searchText}
                                onChange={handleSearch}
                              />
                            </div>
                          </Col>

                          {/* Botón Limpiar */}
                          <Col xs={12} sm={6} md={3} lg={1}>
                            <Button
                              type="primary"
                              onClick={handleClearFilters}
                              icon={<ClearOutlined />}
                              style={{ width: "100%", marginTop: "24px" }}
                              disabled={
                                !(
                                  selectedDepartamento ||
                                  searchText ||
                                  selectedMunicipio ||
                                  selectedModalidad
                                )
                              }
                            >
                              {" "}
                            </Button>
                          </Col>

                          <Col xs={12} sm={6} md={3} lg={1}>
                            <Button
                              type="primary"
                              onClick={fetchVisitasTecnicas}
                              icon={<ReloadOutlined />}
                              style={{ width: "100%", marginTop: "24px" }}
                            >
                              {" "}
                            </Button>
                          </Col>
                          {/* Botón Exportar data */}
                          {permissionExport && (
                            <Col
                              xs={12}
                              sm={6}
                              md={3}
                              lg={3}
                              style={{
                                marginTop: "24px",
                                borderColor: "#52c41a",
                              }}
                            >
                              <ExportVisitasTecnicasSostenibilidad
                                dataCompleta={filteredData}
                              ></ExportVisitasTecnicasSostenibilidad>
                            </Col>
                          )}

                          {/* Botón Crear visita tecnica */}
                          <Col xs={12} sm={6} md={3} lg={3}>
                            {permissionInsert && (
                              <Button
                                type="primary"
                                style={{
                                  marginTop: "24px",
                                  backgroundColor: "#52c41a",
                                  borderColor: "#52c41a",
                                }}
                                icon={<PlusOutlined />}
                                onClick={() => {
                                  setInitialData({}); // Restablece initialData para crear una nueva novedad
                                  setShowFormModal(true); // Abre el modal
                                }}
                              >
                                Nuevo
                              </Button>
                            )}
                          </Col>

                          {/* Total */}
                          <Col xs={12} sm={6} md={3} lg={3}>
                            <Card
                              size="small"
                              style={{
                                marginTop: "24px",
                                textAlign: "center",
                                backgroundColor: "#f0f5ff", // Fondo azul claro
                              }}
                            >
                              <Statistic
                                title="Total Visitas"
                                value={filteredData.length}
                                valueStyle={{
                                  color: "#1890ff",
                                  fontWeight: "bold",
                                }}
                              />
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>

                  <div className="row mb-4">
                    <div className="col-12">
                      {filteredData.length > 0 ? (
                        <Table
                          columns={columns}
                          dataSource={filteredData}
                          rowKey="id"
                          bordered
                          scroll={{ y: 500, x: "max-content" }}
                          pagination={{
                            current: currentPage, // página actual
                            pageSize: pageSize, // filas por página
                            total: filteredData.length, // total de registros
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50", "100"],
                            showTotal: (total, range) =>
                              `${range[0]}-${range[1]} de ${total} registros`,
                            onChange: (page, size) => {
                              setCurrentPage(page);
                              setPageSize(size);
                            },
                          }}
                        />
                      ) : (
                        <div style={{ textAlign: "center", margin: "20px" }}>
                          <Alert
                            message="No hay resultados"
                            description="No se encontraron visitas técnicas que coincidan con tu búsqueda."
                            type="info"
                            showIcon
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
      {/* Modal para el formulario de novedades */}
      {showFormModal && (
        <Modal
          open={showFormModal}
          onCancel={() => {
            handleCancel();
          }} // Cierra el modal
          footer={null} // Sin pie de modal
          width={1200} // Ajusta el ancho del modal aquí
        >
          <FormularioVisitaTecnicaSostenibilidad
            initialData={initialData}
            onClose={() => setShowFormModal(false)} // Pasar la función para cerrar el modal
            fetchData={fetchVisitasTecnicas}
          />
        </Modal>
      )}
    </>
  );
};

export default TablaVisitaTecnicaSostenibilidad;
